import React, { useState, useEffect } from 'react';
import { Button, FormControl, TextField } from "@material-ui/core";
import '../../../styles/banner.scss';
import '../../../styles/landing-common.scss';
import config from '../../config/config';
import GoogleMaps from '../../common/GoogleMap/GoogleMaps';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Modalpopup from '../Modalpopups/Modalpopup';
import Modalpopupcalquemarket from '../Modalpopups/Modalpopupcalquemarket';
import CustomDrawer from '../../common/CustomDrawer/CustomDrawer';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Link as Li } from 'react-router-dom';
import { useFormik } from 'formik';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useGAEventsTracker } from '../../../util/gtag';
import CircularProgress from '@material-ui/core/CircularProgress';

const PopupFooter = () => {
    return (
        <div className="container-fluid float-right">
            <p className="ft-right pd-10 px-2"><b>Lending partner?</b> See more
                <Li
                    activeclass="active"
                    to="lending-partner"
                    spy={true}
                    smooth="true"
                    offset={-70}
                    duration={500}
                    style={{ color: '#fff' }}
                >
                    <ChevronRightIcon />
                </Li></p>
        </div>
    )
}

export default function TradeInMortgage(props) {
    const GAEventTracker = useGAEventsTracker("/Get Started")
    const GAEventTrackerDrawerEnter = useGAEventsTracker(window.location.pathname)
    const [openSubmit, setOpenSubmit] = React.useState(false);
    const [address, setAddress] = useState("");
    const [itemstype, setItemstype] = useState([]);
    const [openCalque, setOpenCalque] = useState(false);
    const [zipcodeExists, setZipCodeExists] = useState(false);
    const [validateUserInfo, setValidateUserInfo] = useState(false)
    const [openFailure, setOpenFailure] = useState(false)
    const [openSuccess, setOpenSuccess] = useState(false)
    const [detail, setDetail] = React.useState('');
    const [severity_type, setSeverityType] = React.useState('');
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [errorsOut, seterrorsOut] = useState()
    const [gmapErr, setGmapErr] = useState(false)
    const handleClose1 = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };
    const vertical = 'top';
    const horizontal = 'center';

    const onSubmit = values => {
        var postUserQue = {
            first_name: values.first_name,
            last_name: values.last_name,
            email: values.email,
            "location": props.values && props.values.property_address.street_address,
            partner_id: props?.partner?.partner_id ? props.partner.partner_id : null,
        }
        let authorise = process.env.REACT_APP_API_KEY;
        fetch(`${config.baseUrlCP}email-for-validate-zipcode/`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `${authorise}`,
                    'Content-Type': 'application/json',
                    'Accept-Encoding': 'gzip, deflate',
                },
                body: JSON.stringify(postUserQue),
            })
            .then(async response => {
                const results = await response.json()
                if (response.status === 201 || response.status === 200) {
                    setDetail(results.message);
                    setSeverityType("success");
                    setOpenSuccess(!openSuccess);
                    setOpenSubmit(false)
                    setOpenSnackbar(true)
                    setValidateUserInfo(false)
                    formik.setFieldValue('first_name', '')
                    formik.setFieldValue('last_name', '')
                    formik.setFieldValue('email', '')
                    formik.setFieldValue('location', '')
                    setOpenCalque(false)
                }
                else {
                    if (results.detail) {
                        setDetail(results.message)
                        setSeverityType("error");
                        setOpenFailure(!openFailure);
                        setOpenSubmit(false)
                        setOpenSnackbar(true)
                        formik.setFieldValue('first_name', '')
                        formik.setFieldValue('last_name', '')
                        formik.setFieldValue('email', '')
                        formik.setFieldValue('user_question', '')
                        await sleep(2000);
                    } else {
                        setSeverityType("error");
                    }
                }
            })
            .catch((error) => {
                setDetail("Something Went Wrong!")
                setSeverityType("error");
                setOpenSnackbar(true)
                setOpenSubmit(false)
            })
    }
    const initialValues = {
        first_name: '',
        last_name: '',
        email: '',
        "location": ''
    }
    const validate = values => {
        let errors = {};

        if (values.first_name.trim() === '') {
            errors.first_name = "Please enter first name"
        }
        if (values.last_name.trim() === '') {
            errors.last_name = "Please enter last name"
        }
        if (values.email.trim() === '') {
            errors.email = "Please provide a valid Email Address"
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'Please provide a valid Email Address';
        }

        return errors;
    }
    const formik = useFormik({
        initialValues,
        onSubmit,
        validate,
    });
    const handleClickOpen2 = () => {
        setOpenSubmit(!openSubmit);
    };
    const handlePopupSubmit = (event) => {
        setValidateUserInfo(true)
        if (!event.detail || event.detail == 1) { return true; }
        else { event.preventDefault(); }
    }
    const handleClickOpener = () => {
        setOpenCalque(!openCalque)
    };
    const handleZipCode = (event) => {
        props.setValidateControl(true)
        props.setPropertyErr(false)
        props.setDisplayError(true)
        let postData = {
            "zip_code": props.values.property_address ? props.values.property_address.zip_code : null
        }
        let authorise = process.env.REACT_APP_API_KEY;
        fetch(`${config.baseUrlCP}validate-zipcode/`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `${authorise}`,
                    'Content-Type': 'application/json',
                    'Accept-Encoding': 'gzip, deflate',
                },
                body: JSON.stringify(postData),
            })
            .then(async response => {
                const results = await response.json()
                if (response.status === 201 || response.status === 200) {
                    props.GAtimer()
                    props.GAtimerFinish()
                    setZipCodeExists(results.is_operating_area)
                    if (results.is_operating_area == false) {
                        setOpenCalque(true)
                        props && props.setErrDisplay(false)
                    } else {
                        setOpenCalque(false)
                        props.drawerHandleOpen();
                        props.handleReset();
                        props && props.setErrDisplay(false)
                    }
                }
                else {
                    setOpenCalque(false)
                    props && props.setErrDisplay(false)
                    setGmapErr(results.zip_code[0])
                }
                if (Object.keys(props.errors).length !== 0 && props.errors.property_type == undefined && props.errors.street_address == undefined) {
                    GAEventTrackerDrawerEnter("UserEnteredQuestionnaire", 1)
                }
            })
            .catch((error) => {
            })
    }

    useEffect(() => {
        props.setSubmitSuccess(true)
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        let isMounted = true;
        setTimeout(() => {
            if (isMounted) {
                seterrorsOut(props.errors)
            }
        });
        return () => {
            isMounted = false;
        }
    }, [props.errors])

    useEffect(() => {
        let isMounted = true;
        if (openSnackbar == true) {
            setTimeout(() => {
                if (isMounted) {
                    setOpenSnackbar(false)
                }
            }, 3000)
        }
        return () => {
            isMounted = false;
        }
    }, [openSnackbar])

    useEffect(() => {
        let isMounted = true;
        fetch(`${config.baseUrl}get-property-type/`,
            {
                headers: {
                    "Authorization": `${process.env.REACT_APP_API_KEY}`,
                    'Accept-Encoding': 'gzip, deflate',
                }
            })
            .then(async response => {
                const result = await response.json()
                if (response.status === 201 || response.status === 200) {
                    if (isMounted) {
                        setItemstype(result)
                    }
                }
                else if (response.status === 403) {
                    localStorage.setItem('access_token', '')
                }
            }
            )
            .catch((error) => {
                console.error('error message', error)
            })
        return () => {
            isMounted = false;
        }
    }, [])

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }
    function calqueMarket() {
        return (
            <>
                <form onSubmit={formik.handleSubmit} noValidate>
                    <div className="container d-none d-md-block">
                        <div className="row">
                            <div className="col-6 p-5">
                                <h2 className="jost-bold">WE'RE WORKING ON IT!</h2>
                                <p className="pt-4">Thanks for your interest in The Trade-In Mortgage™!Calque is not currently operating in your market, but
                                    we’re expanding fast.</p>
                                <p>If you give us your name and email, we will reach out once we arrive.</p>
                            </div>
                            <div className="col-6">
                                <div className="col-12 top-padding-small py-3">
                                    <h6>Name</h6>
                                    <div className="row">
                                        <div className="col-6">
                                            <TextField
                                                className="w-100"
                                                placeholder="First Name"
                                                type="text"
                                                name="first_name"
                                                onChange={formik.handleChange}
                                                value={formik.values.first_name.trimStart()}
                                                variant="outlined"
                                            />
                                            {validateUserInfo === true ? formik.errors.first_name ?
                                                <div className="error-msg">{formik.errors.first_name}</div> : ''
                                                : ''}
                                        </div>
                                        <div className="col-6">
                                            <TextField
                                                className="w-100"
                                                placeholder="Last Name"
                                                name="last_name"
                                                type="text"
                                                onChange={formik.handleChange}
                                                value={formik.values.last_name.trimStart()}
                                                variant="outlined"
                                            />
                                            {validateUserInfo === true ? formik.errors.last_name ?
                                                <div className="error-msg">{formik.errors.last_name}</div> : ''
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 py-3">
                                    <h6>Email Address</h6>
                                    <div className="row">
                                        <div className="col-12">
                                            <TextField
                                                placeholder="Email"
                                                variant="outlined"
                                                name="email"
                                                type="text"
                                                onChange={formik.handleChange}
                                                value={formik.values.email.trimStart()}
                                                className="w-100"
                                            />
                                            {validateUserInfo === true ? formik.errors.email ?
                                                <div className="error-msg">{formik.errors.email}</div> : ''
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 py-3">
                                    <div className="row">
                                        <div className="col-12">
                                            <Button
                                                disableelevation="true"
                                                type="submit"
                                                variant="contained"
                                                color="inherit"
                                                className="w-100"
                                                style={{ height: '50px', backgroundColor: '#FBC04E' }}
                                                onClick={(e) => { handlePopupSubmit(e) }}
                                            >
                                                Submit Now
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container d-block d-md-none">
                        <div>
                            <div className="p-2">
                                <h2 className="jost-bold">WE'RE WORKING ON IT!</h2>
                                <p className="pt-4">Thanks for your interest in The Trade-In Mortgage™ <sup style={{ fontSize: '1.5vh' }}>TM</sup>!Calque is not currently operating in your market, but
                                    we’re expanding fast.</p>
                                <p>If you give us your name and email, we will reach out once we arrive.</p>
                            </div>
                            <div>
                                <div className="top-padding-small py-3">
                                    <h6>Name</h6>
                                    <div>
                                        <div>
                                            <TextField
                                                className="w-100"
                                                placeholder="First Name"
                                                type="text"
                                                name="first_name"
                                                onChange={formik.handleChange}
                                                value={formik.values.first_name.trimStart()}
                                                variant="outlined"
                                            />
                                            {validateUserInfo === true ? formik.errors.first_name ?
                                                <div className="error-msg">{formik.errors.first_name}</div> : ''
                                                : ''}
                                        </div>
                                    </div>
                                    <div className="pt-3">
                                        <div>
                                            <TextField
                                                className="w-100"
                                                placeholder="Last Name"
                                                name="last_name"
                                                type="text"
                                                onChange={formik.handleChange}
                                                value={formik.values.last_name.trimStart()}
                                                variant="outlined"
                                            />
                                            {validateUserInfo === true ? formik.errors.last_name ?
                                                <div className="error-msg">{formik.errors.last_name}</div> : ''
                                                : ''}
                                        </div>

                                    </div>
                                </div>
                                <div className="py-3">
                                    <h6>Email Address</h6>
                                    <div>
                                        <div>
                                            <TextField
                                                placeholder="Email"
                                                variant="outlined"
                                                name="email"
                                                type="text"
                                                onChange={formik.handleChange}
                                                value={formik.values.email.trimStart()}
                                                className="w-100"
                                            />
                                            {validateUserInfo === true ? formik.errors.email ?
                                                <div className="error-msg">{formik.errors.email}</div> : ''
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="py-3">
                                    <div>
                                        <Button
                                            disableelevation="true"
                                            type="submit"
                                            variant="contained"
                                            color="inherit"
                                            className="w-100"
                                            style={{ height: '50px', backgroundColor: '#FBC04E' }}
                                            onClick={(e) => { handlePopupSubmit(e) }}
                                        >
                                            Submit Now
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </>
        )
    }

    function Contactus() {
        return (
            <>
                <div className="container-fluid m-0 top-padding-small bottom-padding-main px-md-5">
                    <div className="row px-md-5">
                        <div className="col-12 px-md-5">
                            <div className="justify-content-md-between align-items-md-center">
                                <h3 className="headerfont">Contact Us</h3>
                                <div className="contentfonthead">To speak with a Calque representative, call</div>
                                <div className="contentfont">
                                    <a className="tel" href={`tel:${props?.contactGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.contactGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Or send an email to</div>
                                <div className="contentfont">
                                    <a className="mailto" href={`mailto:${props?.emailGlobal?.application_config_value}`} style={{ cursor: 'pointer', color: 'black' }}>
                                        <b>{props?.emailGlobal?.application_config_value}</b>
                                    </a>
                                </div>
                                <div className="contentfonthead">Our address is</div>
                                <div className="contentfont">
                                    <b>
                                        <p className="contactAddress">
                                            {props?.addressGlobal?.application_config_value}
                                        </p>
                                    </b>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <div>
            <div className="col-12">
                <div className="row position-relative">
                    <div className="p-0 d-sm-none d-none d-md-block width-100">
                        <img src="assets/images/banner_home_original.webp" draggable="false" alt="home purchased using Trade-In Mortgage" style={{ objectFit: 'cover', height: '85vh', width: '100%' }} />
                    </div>
                    <div className="d-none d-md-block col-md-5 col-lg-5 position-absolute pl-4 pt-5">
                        <div className="d-flex justify-content-center align-items-center w-100 h-100">
                            <div className="pl-2">
                                <div className="col-12 p-2">
                                    <h1 className="jost-bold main_header">The Trade-In Mortgage<span style={{ fontSize: '2rem' }}>™</span></h1>
                                    <h1 className="sub_header">
                                        Use the equity in your current home to buy your next home.
                                    </h1>
                                </div>
                                <div className="col-12 p-1 p-md-none px-3 jost-medium">
                                    <GoogleMaps handleChange={props.handleChange} handleLocation={props.handleLocation} {...props} values={props.values} setFieldValue={props.setFieldValue} setAddress={setAddress} address={address} errors={props.errors} errorsOut={errorsOut} errDisplay={props.errDisplay} gmapErr={gmapErr} validateControl={props.validateControl} setSubmitSuccess={props.setSubmitSuccess} submitSuccess={props.submitSuccess} setDisplayError={props.setDisplayError} displayError={props.displayError} />
                                </div>
                                <div className="col-12 p-0 jost-medium" >
                                    <FormControl variant="outlined" className="property-select w-100 px-3 py-1">
                                        <select
                                            name="property_type_id"
                                            onChange={(e) => { props.handleChange(e) }}
                                            value={props.values.property_type_id ? props.values.property_type_id : 'Property Type'}
                                            displayempty="true"
                                            style={{ height: '54px', backgroundColor: '#fff', color: '#000'}}
                                            inputprops={{ 'aria-label': 'Without label' }}
                                            required
                                        >
                                            <option values="" disabled>Property Type</option>
                                            {itemstype.map((item) => (
                                                <option key={item.property_type_id} value={item.property_type_id}>
                                                    {item.property_type}
                                                </option>
                                            ))}
                                        </select>
                                        {errorsOut && props.validateControl === true && props.errDisplay == false && props.propertyErr == false ? errorsOut.property_type_id && errorsOut.property_type_id ?
                                            <div className="error-msg pt-1">{errorsOut.property_type_id}</div> : ''
                                            : ''}
                                    </FormControl>
                                </div>

                                <div className="col-12 p-0">
                                    <div className="px-3 py-3 w-100">
                                        <Button
                                            disableelevation="true"
                                            variant="contained"
                                            color="inherit"
                                            type={props.submitSuccess === true ? "submit" : "button"}
                                            className="w-100 tradebtn jost-bold"
                                            style={{ height: '54px', backgroundColor: '#FBC04E' }}
                                            onClick={(e) => { GAEventTracker('Get Started', 1); handleZipCode(e) }}
                                            {...{
                                                "aria-haspopup": "true",
                                            }}
                                        >
                                            Get Started
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7 p-0 d-sm-block  d-block d-md-none">
                        <div className="" style={{ width: '100%' }}>
                            <img src="assets/images/banner_home_original-min.webp" draggable="false" alt="home purchased using Trade-In Mortgage" style={{ objectFit: 'contain', width: '100%' }} />
                        </div>
                    </div>
                    <div className="col-sm-12 d-md-none primary-background text-white" style={{ height: '480px', backgroundColor: '#2661AB' }}>
                        <div className="d-flex justify-content-center align-items-center w-100 h-100">
                            <div className="p-lg-5 p-md-2 px-sm-3 py-sm-4 px-2 py-4">
                                <div className="col-12 p-2">
                                    <h1 className="jost-bold main_header">The Trade-In Mortgage<span style={{ fontSize: '2rem' }}>™</span></h1>
                                    <p className="sub_header">
                                        Use the equity in your current home to buy your next home.
                                    </p>
                                </div>
                                <div className="col-12 p-1 px-2 jost-medium">
                                    <GoogleMaps handleChange={props.handleChange} {...props} values={props.values} setFieldValue={props.setFieldValue} setAddress={setAddress} address={address} errors={props.errors} validateDisplay17={props.validateDisplay17} validateDisplay18={props.validateDisplay18} errorsOut={errorsOut} validateControl={props.validateControl} setSubmitSuccess={props.setSubmitSuccess} submitSuccess={props.submitSuccess} setDisplayError={props.setDisplayError} displayError={props.displayError} gmapErr={gmapErr} />
                                </div>
                                <div className="col-12 p-0 jost-medium" >
                                    <FormControl variant="outlined" className="property-select w-100 px-2 py-1">
                                        <select
                                            name="property_type_id"
                                            onChange={(e) => { props.handleChange(e) }}
                                            value={props.values.property_type_id ? props.values.property_type_id : 'Property Type'}
                                            displayempty="true"
                                            style={{ height: '54px', backgroundColor: '#fff', color: '#000' }}
                                            inputprops={{ 'aria-label': 'Without label' }}
                                            required
                                        >
                                            <option values="" disabled>Property Type</option>
                                            {itemstype.map((item) => (
                                                <option key={item.property_type_id} value={item.property_type_id}>
                                                    {item.property_type}
                                                </option>
                                            ))}
                                        </select>
                                        {errorsOut && props.validateControl === true && props.errDisplay == false ? errorsOut.property_type_id && errorsOut.property_type_id ?
                                            <div className="error-msg pt-1">{errorsOut.property_type_id}</div> : ''
                                            : ''}
                                    </FormControl>
                                </div>
                                <div className="col-12 p-0">
                                    <div className="px-2 py-3 w-100">
                                        <Button
                                            variant="contained" disableelevation="true"
                                            color="inherit"
                                            type={props.submitSuccess === true ? "submit" : "button"}
                                            className="w-100 jost-bold"
                                            style={{ height: '54px', backgroundColor: '#FBC04E' }}
                                            onClick={(e) => { GAEventTracker('Get Started', 1); handleZipCode() }}
                                            {...{
                                                "aria-haspopup": "true",
                                            }}
                                        >
                                            Get Started
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-none d-md-block d-sm-none" style={{ backgroundColor: '#fff' }}>
                <div className="content-subinfoDefault">
                    <div className="content-subinfoDefault-content col-12" style={{ backgroundColor: 'lightslategrey', color: '#fff' }} >
                        <div className="d-flex justify-content-around align-items-top p-2 px-5">
                            <div className="px-4 text-box">
                                <h4 className="montserrat-bold text-center">More Convenience</h4>
                                <p className="p-2 m-0 text-justify" id="more-covenience">Buy your dream home now and sell your current home when you’re ready.</p>
                            </div>
                            <div className="separator"></div>
                            <div className="px-4 text-box more-confidence-container">
                                <h4 className="montserrat-bold text-center">More Confidence</h4>
                                <p className="pt-2 m-0 text-justify" id="more-confidence">Submit non-contingent offers as good as cash and win.</p>
                            </div>
                            <div className="separator"></div>
                            <div className="px-4 text-box">
                                <h4 className="montserrat-bold text-center" id="more-freedom-header">More Freedom</h4>
                                <p className="pt-2 m-0 text-justify" id="more-freedom">Use our open platform to work with the real estate agent and lender of your choice.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-block d-md-none">
                <div className="banner-subinfoDefault-content col-12" style={{ backgroundColor: 'lightslategrey', color: '#fff', borderRadius: '0px' }}>
                    <div className="row">
                        <div className="col-12 px-3 py-4 text-center">
                            <h4 className="montserrat-bold pt-2">More Convenience</h4>
                            <p className="p-2 m-0">Buy your dream home now and sell your current home when you’re ready.</p>
                        </div>
                        <div className="col-12 px-3 py-4 text-center">
                            <h4 className="montserrat-bold pt-2">More Confidence</h4>
                            <p className="p-2 m-0">Submit non-contingent offers as good as cash and win.</p>
                        </div>
                        <div className="col-12 px-3 py-4 text-center">
                            <h4 className="montserrat-bold pt-2">More Freedom</h4>
                            <p className="p-2 m-0">Use our open platform to work with the real estate agent and lender of your choice.</p>
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleClose1}
                anchorOrigin={{ vertical, horizontal }} >
                <Alert onClose={handleClose1} severity={severity_type}>
                    <div className="error" style={{ color: 'white' }}>
                        <span>{detail}</span>
                    </div>
                </Alert>
            </Snackbar>
            <Modalpopup open={openSubmit} handleClickOpen={handleClickOpen2} contact={Contactus()} PopupFooter={PopupFooter()} />
            <Modalpopupcalquemarket open={openCalque} handleClickOpener={handleClickOpener} contactData={calqueMarket()} />
            {props.cdrawerHome === false &&
                <CustomDrawer cdrawer={props.cdrawer} loader={props.loader} handleProgress={props.handleProgress} formik={props.formik} {...props} handleNext={props.handleNext} handleChange={props.handleChange} values={props.values} getEstimateButton={props.getEstimateButton} ValidateFinalError={props.ValidateFinalError} gaUserNotAnswered={props.gaUserNotAnswered} setGaUserNotAnswered={props.setGaUserNotAnswered} GAtimerFinish={props.GAtimerFinish} click_id={props.click_id} gclid={props.gclid} linked_in={props.linked_in} lead_activity_id={props.lead_activity_id} facebook_pixel={props.facebook_pixel} 
                setCaptchaValue={props.setCaptchaValue}
                captchaValue={props.captchaValue} 
                validateDisplay10={props.validateDisplay10}
                />
            }
        </div>
    )
}
